import { request } from '@h3/request';
import * as Api from './constant';
/** 获取第三方连接 */
export const getConnectConfigList = (params) => request(Api.ConnectConfigList, {
    method: 'post',
    data: params,
    disableBizError: true,
});
/** 新增第三方连接 */
export const addConnectConfig = (params) => request(Api.ConnectConfigAdd, {
    method: 'post',
    data: params,
    disableBizError: true,
});
/** 编辑更新第三方连接 */
export const updateConnectConfig = (params) => request(Api.ConnectConfigUpdate, {
    method: 'post',
    data: params,
    disableBizError: true,
});
/** 新增第三方连接(编码模式) */
export const addConnectCodingConfig = (params) => request(Api.ConnectCodingConfigAdd, {
    method: 'post',
    data: params,
    disableBizError: true,
});
/** 编辑第三方连接(编码模式) */
export const updateConnectCodingConfig = (params) => request(Api.ConnectCodingConfigUpdate, {
    method: 'post',
    data: params,
    disableBizError: true,
});
/** 删除第三方连接 */
export const deleteConnectConfig = (params) => request(Api.ConnectConfigDelete, {
    method: 'post',
    data: params,
    disableBizError: true,
});
/** 获取第三方连接详情 */
export const getConnectConfigDetail = (params) => request(Api.ConnectConfigDetail, {
    method: 'post',
    data: params,
    disableBizError: true,
});
/** 禁用启用第三方连接 */
export const setConnectConfigStatus = (params) => request(Api.ConnectConfigStatus, {
    method: 'post',
    data: params,
    disableBizError: true,
});
/** 执行或者调试第三方连接 */
export const invokeConnectionConfig = (params) => request(Api.ConnectionConfigInvoke, {
    method: 'post',
    data: params,
    disableBizError: true,
});
/** 查看当前连接的表单使用情况 */
export const getConnectionUsageList = (params) => request(Api.ConnectionUsageList, {
    method: 'post',
    data: params,
    disableBizError: true,
});
